import * as CONSTANTS from './constants';
import {
  getAttributeFromElement,
  isAttributeActive,
} from '../../node-utils';

import {
  isStepModal,
  createDialogInstance,
  addCloseEventIntoDialog,
  refreshContent,
  createStepContent,
  calculateModalBodyHeight,
} from './modal-utils';

import './modalBus';

function calculateOnFooterChange($modal) {
  const $modalContent = $('.modal-content', $modal);

  $('[role="next"]', $modal).click(() => {
    calculateModalBodyHeight($modalContent);
    calculateOnFooterChange($modal);
  });

  $('[role="prev"]', $modal).click(() => {
    calculateModalBodyHeight($modalContent);
    calculateOnFooterChange($modal);
  });
}
/**
 * Show dialog
 * @param {object} modalData
 */
function showDialog(modalData) {
  const $modal = createDialogInstance(modalData);
  const isFull = modalData.size === CONSTANTS.FULL_MODAL;

  if (isFull) {
    $('.modal-dialog', $modal).addClass('modal-full');
  }

  const $modalContent = $('.modal-content', $modal);
  $modal.attr('data-modal-type', modalData.type);

  addCloseEventIntoDialog($modal);

  $modal.on('shown.bs.modal', () => {
    calculateModalBodyHeight($modalContent);
    calculateOnFooterChange($modal);
    $(document).trigger('show.bs.modal', $modal);
  });

  $(window).on('resize', () => {
    calculateModalBodyHeight($modalContent);
  });
}

function openStepDialog(totalSteps, currentStep, modalData) {
  modalData.message = createStepContent(
    totalSteps,
    currentStep,
    modalData.bodies,
    modalData.footers
  );

  showDialog(modalData);

  callEventHandlers(
    totalSteps,
    currentStep,
    modalData.bodies,
    modalData.footers
  );
}

function callEventHandlers(totalSteps, currentStep, bodies, footers) {
  const manageModalStep = (currenStep) => {
    const newContent = createStepContent(
      totalSteps,
      currentStep,
      bodies,
      footers
    );

    refreshContent(totalSteps, currentStep, newContent);
    callEventHandlers(totalSteps, currentStep, bodies, footers);
  };

  $('[role="next"]').click(function () {
    currentStep++;
    manageModalStep(currentStep);
  });

  $('[role="prev"]').click(function () {
    currentStep--;
    manageModalStep(currentStep);
  });

  $('[role="modal-close"]').click(function () {
    $('.modal').modal('hide');
  });
}

function getDefaultOptions($modal) {
  return {
    title: getAttributeFromElement($modal, CONSTANTS.DATA_MODAL_TITLE),
    size: getAttributeFromElement($modal, CONSTANTS.DATA_MODAL_SIZE),
    backdrop: getAttributeFromElement($modal, CONSTANTS.DATA_MODAL_BACKDROP),
    closeButton: isAttributeActive($modal, CONSTANTS.DATA_MODAL_CLOSEBUTTON),
    onEscape: isAttributeActive($modal, CONSTANTS.DATA_MODAL_ONESCAPE),
    type: getAttributeFromElement($modal, CONSTANTS.DATA_MODAL_TYPE),
    classes: getAttributeFromElement($modal, 'class')
  };
}

export function callModal(dataAction) {
  const selector = `[data-modal-action="${dataAction}"][role="modal"]`;
  const $modal = $(selector);
  const modalBody = $modal.children('[role="modal-body"]');
  const modalOpts = getDefaultOptions($modal);

  if ($modal) {
    if (isStepModal($modal)) {
      const totalSteps = modalBody.length;
      const currentStep = getAttributeFromElement(
        $modal,
        CONSTANTS.DATA_MODAL_CURRENT_STEP
      );

      modalOpts.bodies = modalBody;
      modalOpts.footers = $modal.children('[role="modal-footer"]');

      openStepDialog(totalSteps, currentStep, modalOpts);
    } else {
      modalOpts.message = $modal.html();
      showDialog(modalOpts);
    }
  }
}

$(document).ready(function () {
  $('[role=modal-dispatcher]').click(function () {
    Utilities.showModalByDataAction($(this).attr('data-action'));
  });
});
